module.exports = __webpack_public_path__ + "img/show.79e05df4.png";